import React, { useEffect, useState } from 'react';
import { PrimitiveCard } from '../PrimitiveCard';
import MainStore, { uniquePrimitives } from '../MainStore';
import { Table } from '../Table';
import CardGrid from '../CardGrid';
import MarkdownEditor from '../MarkdownEditor';
import SummaryCard from '../SummaryCard';
import { HeroIcon } from '../HeroIcon';
import { Accordion, AccordionItem, Button, Select, SelectItem, Tab, Tabs } from '@heroui/react';
import {Icon} from "@iconify/react";
import clsx from 'clsx';
import StringListEditor from '../@components/StringListEditor';
import { ArrowPathIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, ChevronLeftIcon, ChevronRightIcon, Squares2X2Icon, TableCellsIcon } from '@heroicons/react/24/outline';
import { IconButton } from '../@components/IconButton';
import { FlowInstanceOverview } from '../@components/FlowInstanceOverview';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DebouncedInput } from '../@components/DebouncedInput';

  const colorMap = {
    "error": "bg-red-100/50 border-red-700 text-red-700",
    "child_error": "bg-amber-100/50 border-amber-700 text-amber-700",
    "complete": "bg-ccgreen-100/50 border-ccgreen-700 text-ccgreen-800",
    "not_execued": "bg-slate-100/50 border-slate-700 text-slate-700",
  }
  const iconMap = {
    "error": "solar:danger-circle-linear",
    "child_error": "solar:danger-circle-linear",
    "error_skip": "solar:danger-triangle-linear",
    "running": "solar:play-circle-linear",
    "complete": "solar:check-circle-bold",
    "waiting": "solar:minus-circle-linear",
    "not_execued": "solar:minus-circle-linear"
  }
  const iconColor = {
    "error": "text-red-700",
    "child_error": "text-amber-700",
    "error_skip": "text-ccgreen-800",
    "complete": "text-ccgreen-800",
    "running": "text-blue-700",
    "waiting": "text-slate-700",
    "not_execued": "text-slate-700"
  }

export function FlowContent({ primitives, axisData, ...props }) {
    const [listTab, setListTab ] = useState( "sources" )
    const [outputView, setOutputView] = useState("table")
    const [pageSize, setPageSize] = useState(20)
    const [cardSearchText, setCardSearchText] = useState("")
    const [cardPageById, setCardPageById] = useState({})

    const primitivesKey = primitives.map(d=>d.id).join("-")

    useEffect(()=>{
      setCardPageById({})
    }, [outputView, listTab, primitivesKey])

    useEffect(()=>{
      setCardPageById({})
    }, [cardSearchText])
    
    let content = []
    let first

    const resolveLayeredItems = (items = []) => {
      const queue = [...(items ?? [])].filter(Boolean)
      const visited = new Set()
      const collected = []

      while (queue.length > 0) {
        const item = queue.shift()
        if (!item?.id || visited.has(item.id)) {
          continue
        }
        visited.add(item.id)

        const isLayerNode =
          item.type === "summary" ||
          item.type === "query" ||
          item.referenceId === 82

        if (isLayerNode) {
          const nextLayer = item.getResultSources ?? []
          if (nextLayer.length > 0) {
            queue.push(...nextLayer)
            continue
          }
        }
        collected.push(item)
      }

      return uniquePrimitives(collected)
    }

    const resolveDisplayItems = (items = []) => {
      const layeredList = resolveLayeredItems(items ?? [])
      const resultEntityOnly = layeredList.filter((item)=> item && (item.type === "result" || item.type === "entity"))
      return resultEntityOnly.length > 0 ? resultEntityOnly : layeredList
    }
    
    if( primitives.length > 0){
      primitives = primitives.filter(d=>d.type !== "flow")
    }
    
    for( const primitive of primitives){
      const srcPrimitive = primitive.configParent ?? primitive
      const outputSet = Object.entries(primitive.outputs ?? {})
      const outputPins = primitive.outputPinsWithStatus ?? {}
      if( outputPins?.impout?.connected){
        outputSet.push(["impout", {config: "primitive", data: primitive.itemsForProcessing, source: [primitive]}])
      }
      
      
      let thisContent = <></>
      let tableData 
      let empty = true
      let sourceTabItems
      let poolTabItems
      if( props.asList ){
        let itemsForList
        let effectiveListTab = listTab
        if (Array.isArray(props.sourceList) || Array.isArray(props.poolList)) {
          sourceTabItems = resolveDisplayItems(props.sourceList ?? [])
          poolTabItems = resolveDisplayItems(props.poolList ?? [])
          const hasSourceTab = Array.isArray(props.sourceList)
          const hasPoolTab = Array.isArray(props.poolList)
          const sourceCount = (sourceTabItems ?? []).length
          const poolCount = (poolTabItems ?? []).length
          const showPoolTab = hasPoolTab && (!hasSourceTab || poolCount !== sourceCount)
          if (!showPoolTab && effectiveListTab === "pool") {
            effectiveListTab = "sources"
          }
          const selectedList = effectiveListTab === "pool" ? poolTabItems : sourceTabItems
          itemsForList = selectedList
        } else {
          const baseList = props.list ?? (props.filters ? primitive.itemsForProcessingWithFilter(props.filters) : primitive.itemsForProcessing)
          itemsForList = resolveDisplayItems(baseList ?? [])
        }
        tableData = (itemsForList ?? []).filter(d=>d)
        empty = false
      }else if(props.plainData){
        empty = false
        thisContent = <MarkdownEditor initialMarkdown = {props.plainData} className="p-0"/>
      }else{
        if( outputSet.length > 0){
          for(const [name, output] of outputSet){
            if( output?.config === "string_list"){
              empty = false
              thisContent = <StringListEditor 
                                    size="sm"
                                    className='text-slate-600' 
                                    data={output.data}
                                    editable={srcPrimitive.referenceParameters?.fcAllowEdit}
                                    onChange={(d)=>{
                                      primitive.updateSourceDataForPin(name, d)
                                    }}
                                  />
            }else if( output?.config === "primitive"){
              if( output.data?.length > 0){
                empty = false
                tableData = uniquePrimitives( output.data)
              }
            }
          }
          
        }else{
          //tableData = [primitive]
          //empty = false
        }
      }
      const summaryCard = props.summaryPrimitive ? (
        <div className="mb-3">
          <SummaryCard primitive={props.summaryPrimitive} showDetails={true} showSummaryContent={false} />
        </div>
      ) : null;

      if( primitive.type == "page"){
        thisContent = <p>RenderPage</p>
      }else if( tableData ){
        if(tableData.length === 1){
          thisContent = <>
            {summaryCard}
            <PrimitiveCard variant={true} primitive={tableData[0]} title={false}  className="!p-0"/>
          </>

        }else{
          const isCardView = outputView === "small-cards"
          const searchValue = cardSearchText.trim().toLowerCase()
          const filteredTableData = isCardView && searchValue
            ? tableData.filter((item)=>{
                const title = item?.title ?? ""
                const url = item?.referenceParameters?.url ?? ""
                const id = item?.plainId != null ? `#${item.plainId}` : ""
                return `${title} ${url} ${id}`.toLowerCase().includes(searchValue)
              })
            : tableData
          const totalItems = tableData?.length ?? 0
          const filteredItems = filteredTableData?.length ?? 0
          const totalPages = Math.max(1, Math.ceil(filteredItems / pageSize))
          const currentPage = Math.min(cardPageById[primitive.id] ?? 0, totalPages - 1)
          thisContent = <>
              {summaryCard}
              {(props.sourceList || props.poolList) && (
                (() => {
                  const hasSourceTab = Array.isArray(props.sourceList)
                  const hasPoolTab = Array.isArray(props.poolList)
                  const sourceCount = (sourceTabItems ?? []).length
                  const poolCount = (poolTabItems ?? []).length
                  const showPoolTab = hasPoolTab && (!hasSourceTab || poolCount !== sourceCount)
                  const selectedTab = showPoolTab ? listTab : "sources"
                  return (
                <Tabs
                  fullWidth
                  variant="solid"
                  selectedKey={selectedTab}
                  onSelectionChange={(key)=>setListTab(key)}
                  className="mb-2"
                >
                  {hasSourceTab && <Tab key="sources" title={`Sources (${sourceCount})`} />}
                  {showPoolTab && <Tab key="pool" title={`All (${poolCount})`} />}
                </Tabs>
                  )
                })()
              )}
              <div className="flex flex-wrap items-center justify-between gap-2 pb-2">
                <p className="text-xs uppercase tracking-wide text-slate-400">View</p>
                <div className="flex flex-wrap items-center gap-2">
                  <Tabs
                    size="sm"
                    variant="solid"
                    selectedKey={outputView}
                    onSelectionChange={(key)=>setOutputView(key)}
                    classNames={{ tabList: "gap-1" }}
                  >
                    <Tab key="table" title={<TableCellsIcon className="h-4 w-4" />} />
                    <Tab key="small-cards" title={<Squares2X2Icon className="h-4 w-4" />} />
                  </Tabs>
                </div>
              </div>
              {isCardView && (
                <div className="flex flex-wrap gap-2 place-items-center pb-2">
                  <DebouncedInput
                    value={cardSearchText}
                    onChange={(value)=>setCardSearchText(value)}
                    placeholder="Search items..."
                  />
                </div>
              )}
              {outputView === "small-cards" && (
                <>
                  <div className="w-full min-w-0">
                  <CardGrid
                    list={filteredTableData}
                    page={currentPage}
                    pageItems={pageSize}
                    columnConfig={{ sm: 2 }}
                    className="w-full min-w-0 gap-1.5"
                    equalColumns
                    cardProps={{ smallCard: true }}
                  />
                  </div>
                </>
              )}
              {isCardView && (
                <div className="w-full flex space-y-2 @xl:space-y-0 @xl:space-x-4 flex-col @xl:flex-row @xl:justify-between place-items-center pt-3">
                  <div className="flex gap-2 place-items-center justify-between w-full">
                    {filteredItems === totalItems && (
                      <p className="flex min-w-0 shrink text-gray-500 dark:text-gray-300 font-semibold truncate">
                        {totalItems} items
                      </p>
                    )}
                    {filteredItems !== totalItems && (
                      <p className="flex min-w-0 shrink text-gray-500 dark:text-gray-300 font-semibold truncate">
                        {totalItems} filtered to {filteredItems} items
                      </p>
                    )}
                    <div className="flex grow-0 shrink-0 place-items-center gap-2 w-min-content">
                      <Select 
                        variant="bordered" 
                        classNames={{ mainWrapper:"min-w-20" }}
                        label="Items per page" 
                        labelPlacement="outside-left" 
                        selectedKeys={[String(pageSize)]}
                        onChange={e=>{
                          const next = parseInt(e.target.value)
                          if (Number.isFinite(next)) {
                            setPageSize(next)
                          }
                        }}>
                          {["20","50","100"].map(d=><SelectItem textValue={d} key={d}>{d}</SelectItem>)}
                      </Select>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 place-items-center justify-between w-full">
                    <p className="flex shrink-0 text-gray-500 dark:text-gray-300 font-semibold">
                      Page {currentPage + 1} of {totalPages}
                    </p>
                    <div className="flex space-x-2">
                      <Button isIconOnly size="sm" variant="light" isDisabled={currentPage <= 0} onPress={()=>setCardPageById((prev)=>({ ...prev, [primitive.id]: 0 }))}>
                        <ChevronDoubleLeftIcon className="size-4 my-1 -mx-1"/>
                      </Button>
                      <Button isIconOnly size="sm" variant="light" isDisabled={currentPage <= 0} onPress={()=>setCardPageById((prev)=>({ ...prev, [primitive.id]: Math.max(0, currentPage - 1) }))}>
                        <ChevronLeftIcon className="size-4 my-1 -mx-1"/>
                      </Button>
                      <Button isIconOnly size="sm" variant="light" isDisabled={currentPage >= totalPages - 1} onPress={()=>setCardPageById((prev)=>({ ...prev, [primitive.id]: Math.min(totalPages - 1, currentPage + 1) }))}>
                        <ChevronRightIcon className="size-4 my-1 -mx-1"/>
                      </Button>
                      <Button isIconOnly size="sm" variant="light" isDisabled={currentPage >= totalPages - 1} onPress={()=>setCardPageById((prev)=>({ ...prev, [primitive.id]: totalPages - 1 }))}>
                        <ChevronDoubleRightIcon className="size-4 my-1 -mx-1"/>
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              {outputView === "table" && (
                <Table
                    key={primitive.id + (props.filters ? props.filters.map(d=>d.value).join("-") : "")}
                    primitive={primitive}
                    page={0}
                    popout={true}
                    pageItems={20}
                    onExpand={(p)=>MainStore().primitivePopup(p)}
                    data={tableData} 
                    axisData={{
                      column: axisData?.column.reduce((a,c)=>{a[c.idx]=c;return a},{}),
                      row: axisData?.row.reduce((a,c)=>{a[c.idx]=c;return a},{}),
                    }}
                    className='w-full min-h-[24em] max-h-inherit !text-sm'
                  />
              )}
          </>
        }
      }
      if(empty){
          thisContent = <>
            {summaryCard}
            <div className='p-4 flex'>
              <div className='rounded-xl bg-gray-100 w-full p-6 place-items-center'>
                <Icon icon="line-md:gauge-empty" className='w-8 h-8 text-slate-400'/>
                <p className='uppercase font-semibold text-xs text-slate-400'>No Data</p>
              </div>
            </div>
          </>
      }
      first = first ?? primitive.id
      content.push(
        <div
          key={primitive.id}
          className="px-3 my-3 bg-white shadow-sm rounded-md w-full"
        >
          {thisContent}
        </div>
      )
    }

  const status = primitives.map(d=>({...d.flowStatus, primitive: d}))
  const itemsByState = {}
  for( const item of status){
    if( !itemsByState[item.status] ){
      itemsByState[item.status] = []
    }
    itemsByState[item.status].push(item)
  }

  const severityList = status.map(d=>d?.status).filter((d,i,a)=>d && a.indexOf(d)===i)

  let errorIcon = <></>
  let severity = severityList.includes("error") ? "error" : severityList.includes("child_error") ? "child_error" : severityList.includes("error_skip") ? "error_skip" : "none"
  if( severity !== "none" ){
    errorIcon =  <Icon className={iconColor[severity]} icon={iconMap[severity]} width={24} />
  }

  function executionPanel(){
    const colors = colorMap[severity]


    const statusCounts = status.reduce((a,d)=>{a[d.status] = (a[d.status] ?? 0) + 1; return a},{})
    const multipleStatus = Object.keys(statusCounts).length > 1

    const total = status.length

    function section( name, title, singular, plural){

      if(statusCounts[name]){
        let details = <div className='flex flex-col space-y-2'>
          {itemsByState[name].map(d=>{
              const primitive = d.primitive.type === "flowinstance" ? d.primitive : d.primitive.configParent ?? d.primitive
              const showRetry = name === "child_error" || name === "error"
              let innerContent
              const progress = d.primitive.progress

              if( (primitive.type === "search" && d.primitive.primitives.config.allIds.length > 0)){
                const nestedSearches = d.primitive.primitives.config.allItems
                innerContent = <div className='flex flex-col text-sm w-full'>
                  <span className='font-semibold'>{primitive.title}{progress ? ` - ${progress}` : ""}</span>
                  <ul class="list-disc list-outside pl-6 w-full">
                    {nestedSearches.map(d=>{
                      if( !d.processing ){ 
                        return <></>
                      }
                      const hasError = d.processing.query?.error
                      const overrideTextColor = showRetry && !hasError
                      
                      if( hasError ){
                        return <li>
                        <span className='flex flex-col w-full my-1'>
                          <p>Search for {d.searchFor?.title} - {d.processing.query.error.message ?? d.processing.query.error}</p>
                          <div className='flex w-full justify-end flex space-x-2 mb-2'>
                            {<Button variant="bordered" size="sm" onPress={()=>MainStore().sidebarSelect(d.searchFor)}>View</Button>}
                            {(d.processing.query.status === "error" || d.processing.query.status === "rerun") && <Button variant="bordered" size="sm" onPress={()=>d.setFlow("complete")}>Ignore</Button>}
                            {(d.processing.query.status === "rerun") && <Button variant="flat" size="sm" onPress={()=>d.setFlow("error")}>Marked for retry</Button>}
                            {(d.processing.query.status === "complete" || d.processing.query.status === "error") && <Button variant="bordered" size="sm" onPress={()=>d.setFlow("rerun")}>Mark to retry</Button>}
                          </div>
                        </span>
                        </li>
                      }
                      return <li className={clsx(overrideTextColor ? "marker:text-slate-500" : "")}>
                          <span className={clsx('flex w-full place-items-center justify-between', overrideTextColor ? "text-slate-500" : "")}>
                            <p>Search for {d.searchFor?.title}</p>
                            <div className='space-x-2 flex place-items-center p-1'>
                              {(d.processing.query.status === "complete") && <Button variant="light" size="xs" isIconOnly  onPress={()=>d.setFlow("rerun")}><ArrowPathIcon className='size-4 text-gray-400 hover:text-gray-600'/></Button>}
                              {(d.processing.query.status === "running") && <FontAwesomeIcon icon='spinner' className="animate-spin mr-1"/>}
                              {(d.processing.query.status === "rerun" ) && <Button variant="flat" size="sm" onPress={()=>d.setFlow("complete")}>Marked for rerun</Button>}
                              {d.processing?.query?.status === "pending" ? <p className='mr-2'>Queued</p>: <p className='mr-2'>{d.progressStats?.totalCount ?? 0} items</p>}
                            </div>
                          </span>
                          </li>
                      })}
                  </ul>
                </div>
              }else{
                if( d.primitive.type === "flowinstance"){
                  innerContent = <FlowInstanceOverview primitive={d.primitive} status={title}/>
                }else{

                  innerContent = <>
                  <div className='flex flex-col'>
                    <span className='text-sm font-semibold'>{primitive.title}{progress ? ` - ${progress}` : ""}</span>
                    <span className='text-md'>{d.childErrors?.map(d=>d.error).filter((d,i,a)=>a.indexOf(d)===i).join(", ")}</span>
                  {showRetry && <div className='flex w-full justify-end flex space-x-2 mb-2'>
                    {d.severity === "rerun" && <Button variant="flat" size="sm" onPress={()=>d.primitive.setFlow("error")}>Marked for retry</Button>}
                    {d.severity === "error" && <Button variant="bordered" size="sm" onPress={()=>d.primitive.setFlow("rerun")}>Mark to retry</Button>}
                    <Button 
                      onPress={()=>{
                        const flowInstance = d.primitive.findParentPrimitives({type: ["flowinstance"]})[0]
                        
                        MainStore().doPrimitiveAction(flowInstance, "run_flowinstance_from_step", {from: d.primitive?.id, force: true})
                      }}
                      variant="bordered" 
                      size="sm">Run from here</Button>
                  </div>}
                  </div>
                  {!showRetry && <p className='text-sm'>{title}</p>}
                </>
                }
              }
              return <div className='flex flex-col ml-8'>
                <div className={clsx(colorMap[name], "rounded-lg border p-3 flex place-content-between")}>
                  {innerContent}
                </div>
              </div>

              
          })}
          </div>

        return  <AccordionItem key={name} textValue="name" title={
          <div className='flex space-x-2 place-items-center '>
            {<Icon className={iconColor[name]} icon={iconMap[name]} width={38} />}
            <div className='flex-col flex'>
              <span className='uppercase text-slate-500 text-xs font-semibold'>{title}</span>
              <span className='text-sm text-slate-700'>{statusCounts[name] === total ? (total === 1 ? "Item" : "All items") : `${statusCounts[name]} / ${total}`} {statusCounts[name] > 1 ? plural : singular}</span>
            </div>
          </div>
          }>
          {details}
        </AccordionItem>
      }
      return <></>
    }

    return  <Accordion
                selectionMode="multiple"   // allow more than one panel open
                selectionBehavior="toggle"  // clicking an open header closes it
              >
                {section( "error", "Errors", "has an error", "have errors")}
                {section( "child_error", "Nested errors", "has nested errors", "have nested errors")}
                {section( "complete", "Completed", "has completed", "have completed")}
                {section( "running", "Running", "is running", "are running")}
                {section( "waiting", "Waiting", "is waiting", "are waiting")}
                {section( "not_execued", "Not excuted", "has not run", "have not run")}
            </Accordion>
  }
        
    return (
    <div className="py-2 w-full flex flex-col" key={primitives.map(d=>d.id).join("-")}>
      <div className='my-2 flex flex-col'>
          {props.showExecution !== false && executionPanel()}
          <div className="p-0 flex flex-col">
            {content}
          </div>
      </div>
      
      {props.showExecution !== false && <button
        type="button"
        className="w-full rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        onClick={() => {
          const flowInstance = props.flowInstance //primitives[0].findParentPrimitives({type: ["flowinstance"]})[0]
          MainStore().doPrimitiveAction(flowInstance, "run_flowinstance_from_step", {from: primitives[0]?.id, organizationId: MainStore().activeOrganization?.id, force: true})
        }}
      >
        Run from here
      </button>}
    </div>
  );
}
